/* eslint-disable func-names */

import React, { useEffect, useState,useMemo,useCallback } from 'react';
import { Container, Stepper, Step, StepLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import styles from './View.Style';
import withStyles from '@material-ui/core/styles/withStyles';
import defaultImg from 'img/hero_image.png';
import { ChallengeDetails } from './ChallengeDetails';
import { SelectIdeaTemplate } from './IdeaTemplateSelect';
import { EvaluationFlow } from './EvalutionFlow';
import { ChallengeOwner } from './ChallengeOwner';
import { ChallengePreview } from './ChallengePreview';
import PageLoader from 'components_newui/pageLoader/pageLoader';
import CustomButton from 'components_newui/customButton/CustomButton';

const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  title: {
    fontFamily: 'VodafoneRg-bold',
    fontSize: '2.125rem',
    margin: '1rem 0 2rem 0',
    textAlign: 'left',
    paddingTop: '1rem',
    color: '#333',
  },
  backButton: { marginRight: theme.spacing(1) },
  instructions: { marginTop: theme.spacing(1), marginBottom: theme.spacing(1) },
  instructions1: { marginTop: theme.spacing(1), marginBottom: theme.spacing(3) },
}));


function normalizeCoverPhoto(input) {
  if (Array.isArray(input)) return input;

  if (typeof input === 'string') {
    return [{
      src: input,
      name: 'default-image.jpg',
      size: 0,
      key: input,
      file: null
    }];
  }

  return [];
}


const getDefaultValues = (draft = {}, email = '', imageValue = []) => ({
  status:'DRAFT',
  id: draft?.id || '',
  isHackathonChallenge:draft?.isHackathonChallenge || false,
  title: draft?.title || '',
  summary: draft?.summary || '',
  category: draft?.category || '',
  startingDate: draft?.startingDate ? new Date(draft?.startingDate) : null,
  closingDate: draft?.closingDate ? new Date(draft?.closingDate) : null,
  coverPhoto:normalizeCoverPhoto(draft?.image || []),
  termsAndConditions: draft?.termsAndConditions || '',
  templateIdea: draft?.templateIdea || null,
  templateScorecard: draft?.templateScorecard || null,
  communities: draft?.communities || [],
  groupIds: draft?.groupIds || 1,
  challengeOwner: draft?.challengeOwner || email || '',
  isInnovate: draft?.isInnovate ?? true,
});



const today = new Date();
today.setHours(0, 0, 0, 0);
const tomorrow = new Date(today);

tomorrow.setDate(tomorrow.getDate() + 1);


const stepConfig = [
  {
    label: 'Challenge Details',
    component: ChallengeDetails,
    validationSchema: yup.object({
      isHackathonChallenge: yup.string().required('hackthon challenge field is required'),
      title: yup.string()
        .min(3, 'Minimum 3 characters')
        .max(100, 'Maximum 100 characters')
        .required()
        .trim()
        .matches(
          /^[a-zA-Z0-9_ #!?|]*$/,
          'Only letters, numbers, spaces, underscore (_), hash (#), exclamation (!), question mark (?), and pipe (|) are allowed'
        ),
      summary: yup.string().required().trim(),
      category: yup.string().required(),
      status: yup.string(), //this only for condtion check in schema not any purpose 
startingDate: yup.date().nullable().when('status', (status, schema) =>
 status === 'DRAFT'
   ? schema
       .required('Start date is required ')
       .min(today, 'Date must be today ')
   : schema.notRequired()
),


      // startingDate: yup.date().nullable().required().min(today),

      closingDate: yup.date()
      .required('Submission End Date is required')
      .test(
        'is-after-start',
        'Submission End Date must be after Submission Start Date',
        function (endDate) {
          const { startingDate } = this.parent;
          return (
            startingDate &&
            endDate &&
            new Date(endDate) > new Date(startingDate)
          );
        }
      ),
      

      coverPhoto: yup.array()
      .of(
        yup
          .mixed()
          .test(
            'fileSize',
            'Image must be less than 10 MB',
            (value) => {
              if (!value) return false;
    
              // Check if it's a new file
              if (value.file && typeof value.file.size === 'number') {
                return value.file.size / (1024 * 1024) <= 10;
              }
    
              // Check if it's an existing image with size
              if (typeof value.size === 'number' && value.size > 0) {
                // If size is in KB, convert to bytes
                const sizeInBytes = value.size < 10000 ? value.size * 1024 : value.size;
                return sizeInBytes / (1024 * 1024) <= 10;
              }
    
              // If no valid size info, skip validation
              return true;
            }
          )
      )
      .min(1, 'At least one image is required')
      .required('Cover photo is required'),
    

      termsAndConditions: yup.string().required().trim(),
    }),
  },
  {
    label: 'Idea Template Selection',
    component: SelectIdeaTemplate,
    validationSchema: yup.object({
      templateIdea: yup.object().required(),
    }),
  },
  {
    label: 'Evaluation Workflow',
    component: EvaluationFlow,
    validationSchema: yup.object({
      templateScorecard: yup.object().required(),
    }),
  },
  {
    label: 'Owner & Communities',
    component: ChallengeOwner,
    validationSchema: yup.object({
      communities: yup.array()
        .min(1, 'At least one community is required')
        .required('Community selection is required'),
    })
  },
  {
    label: 'Challenge Summary',
    component: ChallengePreview,
    validationSchema: yup.object(),
  },
];



const ChallengeEditFlow = (props) => {
  const {
    getInnovateChallengeDraftIdAddImage,
    draftGetInnovateChallenge,
    getChallengeIntoInnovateDraftFn,
    getCommunitesAsGroup,
    DraftInnovateChallenge,
    getIdeaTemplatelistFn,
    getScorecardTemplatelistFn,
    getInnovateChallengeActiveTypesFn,
    postInnovateChallengeCreateFn,
    putInnovateChallengeEditFn,
    editInnovateChallenge,
    saveDraftChallengeToBackend,
    isAdmin,
    isInnovator,
    userEmail,
    getInnovateChallengeFn,
    getInnovateChallengeIdDetailsLoading,
    getInnovateChallengeIdDetails,
    InnovateChallengeStatus,
    createInnovateChallengeLoading,
    draftGetInnovateChallengeLoading,
    editInnovateChallengeLoading
  } = props || {};

  // const challengeOrganizerEmailList=['dummy@gmail.com', 'dummy2@gmail.com']
  
 const {title:challengeTitle,challengeOrganizerEmailList} = getInnovateChallengeIdDetails || {}
  const { id: editChallengeId } = useParams();
  const addEditFormID = !!editChallengeId;
  const [selectedUsers, setSelectedUsers] = useState([])
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  // const showEmail = isAdmin ? userEmail : 'N/A'
  const currentStep = stepConfig[activeStep];
  
  // const {items} = getInnovateChallengeIdDetails 
  // const defaultValues = useMemo(() => getDefaultValues( showEmail), [ showEmail]);



  useEffect(() => {
    if(!addEditFormID){
      getChallengeIntoInnovateDraftFn?.();
    }
    getInnovateChallengeFn?.(editChallengeId)
    getIdeaTemplatelistFn?.();
    getScorecardTemplatelistFn?.();
    getInnovateChallengeActiveTypesFn?.();
    getCommunitesAsGroup?.();
  }, []);



  const updatedUsers = isInnovator && !isAdmin && userEmail
  ? [...selectedUsers, { value: userEmail }]
  : selectedUsers;


  // const finalUsers = Array.from(
  //   new Map(
  //     [
  //       ...(selectedUsers || []),
  //       //  Convert challengeOrganizerEmailList (string -> object)
  //       // ...(challengeOrganizerEmailList || []),
  //       ...(challengeOrganizerEmailList || []).map(email => ({
  //         value: email,
  //         label: email
  //       })),
  //       //  Add logged-in user conditionally
  //       ...(isInnovator && !isAdmin && userEmail
  //         ? [{ value: userEmail, label: userEmail }]
  //         : [])
  //     ].map(item => {
  //       const value = item.value || item.label;
  
  //       return [
  //         value?.toLowerCase(),
  //         {
  //           ...item,
  //           value,
  //           label: item.label || value
  //         }
  //       ];
  //     })
  //   ).values()
  // );
  

  // const organizerEmails = [...new Set(finalUsers.map(u => u.value))];




  const methods = useForm({
    defaultValues: getDefaultValues(null, userEmail, []),
    resolver: yupResolver(currentStep?.validationSchema),
    mode: 'onChange',
    shouldUnregister: false,
  });
  
  const { handleSubmit, trigger, getValues, reset } = methods;


  const mapEmailsToSelect = (emails = []) => {
    return emails.map(email => ({
      label: email,
      value: email,
    }))
  }
  
  const mergeUniqueUsers = (existingUsers = [], newUsers = []) => {
    const map = new Map()
  
    ;[...existingUsers, ...newUsers].forEach(user => {
      if (user?.value) {
        map.set(user.value, user)
      }
    })
  
    return Array.from(map.values())
  }
  

  const getreposneChallengeOrganizerEmailList = getValues();
  // console.log("handleSave--save challenge", getreposneChallengeOrganizerEmailList)

const finalUsers = Array.from(
 new Map(
   [
     ...(selectedUsers || []),
     //  Convert challengeOrganizerEmailList (string -> object)
     // ...(challengeOrganizerEmailList || []),
     ...(getreposneChallengeOrganizerEmailList?.search || []),
     //  Add logged-in user conditionally
     ...([{ value: userEmail, label: userEmail }] )
   ].map(item => {
     const value = item.value || item.label;
     return [
       value?.toLowerCase(),
       {
         ...item,
         value,
         label: item.label || value
       }
     ];
   })
 ).values()
);

const organizerEmails = [...new Set(finalUsers.map(u => u.value))];





  const transformChallengeDataToFormValues = (data, email = '', imageValue = []) => {
    console.log("update---0-0-0-0-0--0", data  )
    // console.log("edit flow challenge img path---0-0-0-0-0--0", data?.mainPhoto   )

    const normalizeCommunities = (communityIds, listCommunites) => {
      return communityIds.map(id => {
        const match = listCommunites.find(group => group.id === id);
        return match ? { value: match.id, label: match.name } : { value: id, label: id };
      });
    };
      

  return({
    id: data?.id ?? '',
    isHackathonChallenge: data?.isHackathonChallenge ?? false,
    title: data?.title ?? '',
    summary: data?.desc ?? '', // assuming `desc` is the summary
    category: data?.categoryTypeId ?? '',
    coverPhoto: normalizeCoverPhoto(( data?.image?.url  ||  data?.images?.[0]?.url && String(data.image[0].url)) ?? defaultImg),
    // coverPhoto: normalizeCoverPhoto(data?.images[0]?.url ?? defaultImg),
    startingDate: data?.starts?.dateString ? new Date(Date.parse(data.starts?.dateString)) : null,
    closingDate: data?.ends?.dateString ? new Date(data.ends?.dateString) : null,
    termsAndConditions: data?.termAndCondition ?? '',
    templateIdea: data?.ideaTemplateId ? { id: data.ideaTemplateId } : null,
    templateScorecard: data?.challengeTemplateId ? { id: data.challengeTemplateId } : null,
    // communities: data?.groupListK ?? [],
    communities: normalizeCommunities(data?.groupListK ?? [], props?.listCommunitesChallenge ?? []),
    groupIds:normalizeCommunities(data?.groupListK ?? [], props?.listCommunitesChallenge ?? []),
    // groupIds: data?.groupListK ?? [],
    // challengeOwner: data?.sponsorEmail ?? showEmail,
    challengeOwner: userEmail,
    isInnovate: data?.isInnovate ?? true,
    search: mapEmailsToSelect(data?.challengeOrganizerEmailList || [])
  });

}

  
  const items = getInnovateChallengeIdDetails 

  useEffect(() => {
    if (editChallengeId && items ) {
      const transformed = transformChallengeDataToFormValues(items, userEmail);
      reset(transformed);
    }
  }, [editChallengeId, items ,reset, userEmail]);
  

  useEffect(() => {
    if (editChallengeId) {
      getInnovateChallengeFn?.(editChallengeId)
    }
  }, [editChallengeId]);
  

  const handleNext = useCallback(async () => {
    const isValid = await trigger();
    if (isValid) setActiveStep((prev) => prev + 1);
    window.scrollTo(0,0)
  }, [trigger]);

  const handleBack = useCallback(() => setActiveStep((prev) => prev - 1), []);
  

  const handleReset = () => {
    // reset(defaultValues);
    setActiveStep(0);
  };

  const handleSave = async (data) => {
    // console.log("data--save challenge", data)
    const allData = getValues();
    //  console.log("handleSave--save challenge", allData)

    const allDataWithImg={
      ...allData,
      images:getInnovateChallengeDraftIdAddImage?.image,
      challengeOwner:userEmail,
      organizerEmails
    }
    await putInnovateChallengeEditFn(allDataWithImg);
    reset(data); // Set submitted data as new default
  };
    

  const onSubmit = async (data) => {
    const allData = getValues();
    const allDataWithImg={
      ...allData,
      images:getInnovateChallengeDraftIdAddImage?.image,
      challengeOwner:userEmail,
      organizerEmails
    }
    // console.log("submit- postInnovateChallengeCreateFn editmode -=0-0-0-0-0",data,allDataWithImg)
    // await saveDraftChallengeToBackend(data, showEmail);
    await postInnovateChallengeCreateFn(allDataWithImg);
    reset(data); // Set submitted data as new default
  };

  // const handleSaveDraft = async () => {
  //   const allData = getValues();
  //   await saveDraftChallengeToBackend(allData, showEmail);
  // };
    

  const StepComponent = currentStep?.component;




  if(getInnovateChallengeIdDetailsLoading){
    return <PageLoader isLoadingContent='Loading...' />
  }

  // if (!items || (items && !items[0])) return {}
  // console.log("getInnovateChallengeIdDetails0-0-0-0--0-0-0", getInnovateChallengeIdDetails?.items)
  // console.log("getInnovateChallengeIdDetails0-0-0-0--0-0-0item",items[0], items[0]?.title)
  // const {title,} = items[0] || []

  return (
    <Container>
      <h2 className={classes.title}> Edit Challenge - {challengeTitle}</h2>
      <div className={classes.root}>

        <Stepper activeStep={activeStep} alternativeLabel>
          {stepConfig.map((step) => (
            <Step key={step.label}>
              <StepLabel>{step.label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {activeStep === stepConfig.length ? (
          <div>
            <p className={classes.instructions}>All steps completed</p>
            <CustomButton onClick={handleReset}>Reset</CustomButton>
          </div>
        ) : (
          
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className={classes.instructions}>
                
                <StepComponent {...props} formData={getValues()} mainImageValue={editInnovateChallenge?.coverPhoto || []} 
                  selectedUsers={selectedUsers} onUserChange={setSelectedUsers} isAdmin={isAdmin} userEmail={userEmail}
                  mergeUniqueUsers={mergeUniqueUsers}
                />
              </div>

              <div className={classes.instructions1}>
                <CustomButton
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className={classes.backButton}
                >
                  Back
                </CustomButton>
               

                {activeStep === stepConfig.length - 1 ? (
                  <>
                  
                  <CustomButton
                   variant="contained" 
                   color="primary"
                    onClick={handleSave}
                    className={classes.backButton}
                    disabled={draftGetInnovateChallengeLoading || editInnovateChallengeLoading}
                  >
                     Save Challenge
                  </CustomButton>
                  
                      {InnovateChallengeStatus === "DRAFT" ?
                        <CustomButton type="submit" disabled={createInnovateChallengeLoading} variant="contained" color="primary">
                          Submit Challenge
                        </CustomButton>
                        : null}

                  </>
                ) : (
                  <CustomButton type='button' onClick={handleNext} variant="contained" color="primary">
                    Next
                  </CustomButton>
                )}
              </div>
            </form>
          </FormProvider>

        )}
      </div>
    </Container>
  );
};

export default withStyles(styles)(ChallengeEditFlow);


// const renderStepper = () => (
//   <Stepper activeStep={activeStep} alternativeLabel>
//     {stepConfig.map((step) => (
//       <Step key={step.label}>
//         <StepLabel>{step.label}</StepLabel>
//       </Step>
//     ))}
//   </Stepper>
// );
